import { useBanner } from "../context";
import React from "react";

export default function CloseIcon() {
  const { handleCancel } = useBanner();
  return <button onClick={handleCancel}>✕</button>;
}
